module.exports = __webpack_public_path__ + "img/arw-anchor-red.e381e8b3.svg";